export default{container:"w_DN",gray:"w_DO",white:"w_DP",large:"w_DQ",small:"w_DR",pill:"w_DS",pill2:"w_DT",pill3:"w_DU",pill4:"w_DV",pill5:"w_DW",pill6:"w_DX"};
